class CustomNavSlider {
    constructor(el, opts) {
        if (!el) {
            console.error('CustomNavSlider class constructor requires "el" argument!');
            return;
        }

        let $el              = $(el);
        let sliderPosX       = $el.offset().left;
        let sliderPosY       = $el.offset().top;
        let sliderWidth      = $el.outerWidth();
        let sliderHeight     = $el.outerHeight();
        let sliderLastPointX = sliderPosX + sliderWidth;
        let sliderLastPointY = sliderPosY + sliderHeight;
        let sliderHalfArea   = sliderWidth / 2 + sliderPosX;
        let $sliderNav       = $el.find('[data-slider-nav]');

        this.el = $el;

        $document.on('mousemove', function (event) {
            if (event.pageX >= sliderPosX &&
                event.pageX < sliderHalfArea &&
                event.pageY >= sliderPosY &&
                event.pageY <= sliderLastPointY ) {
                $sliderNav.removeClass(rightClass);
                $sliderNav.addClass(leftClass);
            } else if (event.pageX >= sliderHalfArea &&
                event.pageX < sliderLastPointX &&
                event.pageY >= sliderPosY &&
                event.pageY <= sliderLastPointY )  {
                $sliderNav.removeClass(leftClass);
                $sliderNav.addClass(rightClass);
            } else {
                $sliderNav.removeClass(leftClass);
                $sliderNav.removeClass(rightClass);
            }

            if (event.pageX >= sliderPosX &&
                event.pageX <= sliderLastPointX &&
                event.pageY >= sliderPosY &&
                event.pageY <= sliderLastPointY ) {
                $sliderNav.addClass(showClass);
                $sliderNav.offset({"left": event.pageX, "top": event.pageY});
            } else {
                $sliderNav.removeClass(showClass);
            }
        });
    }
    update() {
        setTimeout(() => {
            let $el = this.el;
            let sliderPosX = $el.offset().left;
            let sliderPosY = $el.offset().top;
            let sliderWidth = $el.outerWidth();
            let sliderHeight = $el.outerHeight();
            let sliderLastPointX = sliderPosX + sliderWidth;
            let sliderLastPointY = sliderPosY + sliderHeight;
            let sliderHalfArea = sliderWidth / 2 + sliderPosX;
            let $sliderNav = $el.find('[data-slider-nav]');

            $document.on('mousemove', function (event) {
                if (event.pageX >= sliderPosX &&
                    event.pageX < sliderHalfArea &&
                    event.pageY >= sliderPosY &&
                    event.pageY <= sliderLastPointY) {
                    $sliderNav.removeClass(rightClass);
                    $sliderNav.addClass(leftClass);
                } else if (event.pageX >= sliderHalfArea &&
                    event.pageX < sliderLastPointX &&
                    event.pageY >= sliderPosY &&
                    event.pageY <= sliderLastPointY) {
                    $sliderNav.removeClass(leftClass);
                    $sliderNav.addClass(rightClass);
                } else {
                    $sliderNav.removeClass(leftClass);
                    $sliderNav.removeClass(rightClass);
                }

                if (event.pageX >= sliderPosX &&
                    event.pageX <= sliderLastPointX &&
                    event.pageY >= sliderPosY &&
                    event.pageY <= sliderLastPointY) {
                    $sliderNav.addClass(showClass);
                    $sliderNav.offset({"left": event.pageX, "top": event.pageY});
                } else {
                    $sliderNav.removeClass(showClass);
                }
            });
        }, 500)
    }
}